module.exports = __webpack_public_path__ + "img/showcase-hero-thumb.71dd1798.png";